import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px;
  border-radius: ${props => props.theme.borderRadiusContainers};
  background-color: ${props => props.theme.backgroundTag};

  img {
    width: ${props => props.theme.thumbnail.width};
    height: ${props => props.theme.thumbnail.height};
    object-fit: cover;
    flex-shrink: 0;
  }
  div {
    min-width: 0;
  }
  p {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .track-title {
    font-family: ${props => props.theme.p2b.ff};
    font-size: ${props => props.theme.p2b.fs};
    color: ${props => props.theme.textLight};
  }
  .track-album {
    font-family: ${props => props.theme.p3r.ff};
    font-size: ${props => props.theme.p3r.fs};
    color: ${props => props.theme.textMedium};
  }
`;
